const useAvatar = (avatar: string | null | undefined, initials?: string) => {
  if (!avatar) {
    return initials?.toUpperCase();
  } else {
    return avatar;
  }
};

export { useAvatar };
